exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".fpEmailInput{margin:20px auto}.body{background:#fff;padding:8px}.incorrect{background:#254863;color:#bbb}.signInLink{color:#6ca5e7;text-decoration:underline;cursor:pointer}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/ForgotPassword.vue"],"names":[],"mappings":"AACA,cACE,gBAAkB,CACnB,AACD,MACE,gBAAkB,AAClB,WAAa,CACd,AACD,WACE,mBAAoB,AACpB,UAAc,CACf,AACD,YACE,cAAe,AACf,0BAA2B,AAC3B,cAAgB,CACjB","file":"ForgotPassword.vue","sourcesContent":["\n.fpEmailInput {\n  margin: 20px auto;\n}\n.body {\n  background: white;\n  padding: 8px;\n}\n.incorrect {\n  background: #254863;\n  color: #BBBBBB\n}\n.signInLink {\n  color: #6CA5E7;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-98bc3740","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ForgotPassword.vue
// module id = 732
// module chunks = 17